// extracted by mini-css-extract-plugin
export default {"page":"MainLayout_page__JeM-F","main":"MainLayout_main__XDITe"};